/** The patient's status page: their tier, progress to the next and what each tier gives. */
export const LOYALTY_STATUS_PATH = "/rewards/status";
